/* eslint-disable */

import axios from 'axios';

export default {
    searchfield: ({ commit }, payload) => {
        return axios.post(payload.url + '/searchfield', payload.search)
            .then(resp => {
                return resp.data;
            });
    },
    getConfig: ({ commit }) => {
        return axios.get('/settings')
            .then(resp => {
                return resp.data;
            });
    },
    updateConfig: ({ commit }, payload) => {        
        return axios.put('/settings/' + payload.id, payload)
            .then(resp => {
                return resp.data;
            });
    }
}